import dataSelect from "@store/dataForSelect/reducers";

import { test_select } from "../../configs/constants";

export default dataSelect(test_select);
